import { ReactNode } from 'react';

import { useBreakpoint } from '@contexts/breakpoints';
import Price from '@components/ui/price';
import { Currencies } from '@constants/constants';
import BottomDrawer from '@components/BottomDrawer/BottomDrawer';
import MilePriceBadge from '@uikit/milePriceBadge';
import { usePageTransitionAnimation } from '@hooks/animations';

import {
  Container,
  PriceDetailsContainer,
  TotalPriceWrapper,
  TotalPriceContainer,
  TotalPriceTitleContainer,
  VerticalSeparator,
  ActionButton,
} from './PriceDetailsDrawerStyle';
import Item from './Item';

export interface PriceDetailsDrawerProps {
  toggleButtonTitle?: string;
  actionButtonTitle?: string;
  totalPrice: number;
  totalPriceTitle?: string;
  totalMilePrice: number;
  currency?: string;
  onNavigate: () => void;
  closable?: boolean;
  disabled?: boolean;
  isLoading?: boolean;
  originalPrice?: number;
  originalCurrency?: string;
  isExpedia?: boolean;
}

const PriceDetailsDrawer = ({
  onNavigate,
  toggleButtonTitle,
  actionButtonTitle = 'Devam Et',
  disabled = false,
  isLoading = false,
  totalPriceTitle = 'Toplam',
  totalMilePrice,
  currency = Currencies.TL,
  totalPrice,
  closable,
  children,
  originalPrice,
  originalCurrency,
  isExpedia,
}: PriceDetailsDrawerProps & { children: ReactNode }) => {
  const { md: isDesktop } = useBreakpoint();
  const { isLoading: isRedirecting } = usePageTransitionAnimation();

  return (
    <BottomDrawer closable={closable} toggleButtonTitle={toggleButtonTitle}>
      {(isToggled: boolean) => (
        <Container isToggled={isToggled}>
          {isToggled ? (
            <>
              <PriceDetailsContainer>{children}</PriceDetailsContainer>
              <VerticalSeparator />
            </>
          ) : null}
          <TotalPriceWrapper>
            {totalPrice ? (
              <TotalPriceContainer>
                <TotalPriceTitleContainer>
                  {totalPriceTitle}
                </TotalPriceTitleContainer>
                <MilePriceBadge milePrice={totalMilePrice} />
                <Price
                  fontSize={isDesktop ? 28 : 18}
                  color='darkGrey'
                  currency={currency}
                  price={totalPrice}
                  format='discount'
                  originalPrice={originalPrice}
                  originalPriceCurrency={originalCurrency}
                  isExpedia={isExpedia}
                />
              </TotalPriceContainer>
            ) : null}
            <ActionButton
              disabled={disabled || isLoading || isRedirecting}
              loading={isLoading || isRedirecting}
              onClick={onNavigate}
              data-testid='prebook-button'
            >
              {actionButtonTitle}
            </ActionButton>
          </TotalPriceWrapper>
        </Container>
      )}
    </BottomDrawer>
  );
};

PriceDetailsDrawer.Item = Item;

export default PriceDetailsDrawer;
